import { useEffect, useState } from 'react'
import { escritorio, type EventoActualizacion } from '../../lib/desktop'
import './chipActualizacion.css'

// Aviso de actualización de la app de ESCRITORIO (electron-updater).
//
// Deliberadamente un chip y no un modal: la actualización no es urgente ni es
// cosa de la persona — se descarga sola y se aplica al siguiente arranque aunque
// nadie toque nada. Interrumpir con un diálogo para eso sería robar la atención
// a mitad de un brief. Mismo lenguaje visual que NetChip (el otro chip de estado)
// para que el chrome no crezca un dialecto nuevo.
//
// El estado 'error' NO se pinta: que una descarga falle es problema del
// cascarón, que reintentará, y no hay nada que la persona pueda hacer al
// respecto. Sale en la consola y ya.
//
// Este chip se monta tarde (dentro de RequireAuth, con la sesión ya resuelta) y el
// actualizador revisa al arrancar, mucho antes. No se pierde nada porque el main
// RETIENE el último evento y lo reenvía cuando la web termina de cargar: sin eso,
// electron-updater emite 'update-available'/'update-downloaded' una sola vez por
// ciclo y el siguiente aviso sería seis horas después.

export function ChipActualizacion() {
  const [evento, setEvento] = useState<EventoActualizacion | null>(null)

  useEffect(() => {
    const d = escritorio()
    if (!d) return
    return d.onUpdate((e) => {
      if (e.state === 'error') {
        console.warn('escritorio: falló la actualización', e.version ?? '')
        setEvento(null)
        return
      }
      setEvento(e)
    })
  }, [])

  if (!evento) return null

  const lista = evento.state === 'descargada'

  return (
    <div className="up-chip" role="status" aria-live="polite">
      <span className="up-dot" aria-hidden="true" />
      {lista ? (
        <>
          <span>Actualización lista</span>
          <span className="up-sep" aria-hidden="true">·</span>
          <button
            type="button"
            className="up-btn"
            onClick={() => void escritorio()?.restartToUpdate()}
          >
            Reiniciar
          </button>
        </>
      ) : (
        <span>Descargando actualización{evento.version ? ` ${evento.version}` : ''}…</span>
      )}
    </div>
  )
}
